import { Injectable, inject } from '@angular/core';
import { ConfigsService } from '@overa/shared';

/**
 * Pages of the IdP itself that the BackOffice links to.
 *
 * They are not screens of this SPA: they run on the IdP with its own session cookie, which is what lets
 * them ask for the strongest credential. Adding a key from here would only have the bearer token, and
 * Identity refuses that on purpose (`PasskeyRegistrationGate`: adding a key needs a session opened with a
 * key).
 */
@Injectable({ providedIn: 'root' })
export class IdentityLinksService {
  private readonly configsService = inject(ConfigsService);

  /**
   * The signed-in person's own keys (`GET {idp}/passkey`): list, add another, revoke one. The base is the
   * same `identityBaseUrl` the security services use, so in a platform session it is that platform's IdP.
   */
  passkeysUrl(): string | null {
    const base: string = (this.configsService.getModuleConfig('overa-security', 'identityBaseUrl') ?? '')
      .replace(/\/+$/, '');
    return base ? `${base}/passkey` : null;
  }

  /** Opens it in another tab: the BackOffice session stays where it was. */
  openPasskeys(): void {
    const url = this.passkeysUrl();
    if (url) window.open(url, '_blank', 'noopener');
  }
}
